export const mutations = {
  setDocMaster: function (state, doc) {
    state.docMaster = doc;
  },
  pushDocMaster: function (state, doc) {
    state.docMaster.push(doc);
  },
  updateDocMaster: function (state, doc) {
    var index = [...state.docMaster].findIndex(
      (e) => e.doc_code == doc.doc_code
    );
    if (index > -1) {
      state.docMaster[index] = doc;
    }
  },
  removeDocMaster: function (state, doc) {
    var index = [...state.docMaster].findIndex(
      (e) => e.doc_code == doc.doc_code
    );
    if (index > -1) {
      state.docMaster.splice(index, 1);
    }
  },
};
